import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { AnaNutricionistaLogo } from './AnaNutricionistaLogo';
import { CarlosFinancieroLogo } from './CarlosFinancieroLogo';
import { MiguelArquitectoLogo } from './MiguelArquitectoLogo';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t,
    language
  } = useLanguage();
  const testimonials = [{
    name: 'Carlos M.',
    role: language === 'es' ? 'Consultor Financiero' : 'Financial Consultant',
    quote: language === 'es' ? 'Tenía miedo de que no quedara profesional. Me entregaron la web en 18 horas y superó todo lo que imaginé. Mis clientes me preguntan quién me hizo la web.' : "I was afraid it wouldn't look professional. They delivered the website in 18 hours and it exceeded everything I imagined. My clients ask me who made my website.",
    logo: <CarlosFinancieroLogo size={48} data-id="element-418" />
  }, {
    name: 'Ana R.',
    role: language === 'es' ? 'Nutricionista' : 'Nutritionist',
    quote: language === 'es' ? 'En serio, en 48 horas. No podía creerlo. Ya tengo 3 clientes nuevos que me encontraron por Google.' : "Seriously, in 48 hours. I couldn't believe it. I already have 3 new clients who found me on Google.",
    logo: <AnaNutricionistaLogo size={48} data-id="element-419" />
  }, {
    name: 'Miguel T.',
    role: language === 'es' ? 'Arquitecto' : 'Architect',
    quote: language === 'es' ? 'Llevaba 2 años diciéndome que iba a hacer una web. Lo hice en un día con Kinetic. Ojalá lo hubiera hecho antes. Vale cada centavo.' : 'I spent 2 years telling myself I was going to make a website. I did it in one day with Kinetic. I wish I had done it sooner. Worth every penny.',
    logo: <MiguelArquitectoLogo size={48} data-id="element-420" />
  }];
  return <section id="testimonios" className="py-24 bg-brand-bg relative overflow-hidden" data-id="element-421">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-purple/5 blur-[120px] rounded-full pointer-events-none" data-id="element-422"></div>

      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-423">
        <div className="text-center mb-16" data-id="element-424">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-425">
            {t('testimonials.title')}
          </h2>
          <p className="text-brand-cyan text-xl font-medium" data-id="element-426">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-427">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-darker border border-white/5 p-8 rounded-2xl relative" data-id="element-428">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-white/5" data-id="element-429" />

              <div className="flex gap-1 mb-6" data-id="element-430">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-cta text-brand-cta" data-id="element-431" />)}
              </div>

              <p className="text-gray-300 text-lg mb-8 relative z-10" data-id="element-432">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-433">
                {testimonial.logo}
                <div data-id="element-434">
                  <h4 className="text-white font-bold" data-id="element-435">{testimonial.name}</h4>
                  <p className="text-gray-400 text-sm" data-id="element-436">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}